import { ASSISTANT_SETTINGS_TAB_FIELDS } from "src/pages/admin/GeneralSettingsConsts";

export const FORMATTING_HANDLERS = {
  [ASSISTANT_SETTINGS_TAB_FIELDS.skillsDashboards]: (value) => {
    const normalizedValue = Array.isArray(value) && value.length > 0 && typeof value[0] === "object"
      ? value.map(item => item.display_key || item.key)
      : value;
    return normalizedValue;
  }
};
